import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Subject} from "rxjs";
import {CountriesPopupComponent} from "../countriespopup/countriespopup.component";
import {CountryService} from "@aparraga/ahoracrypto-client-common/src/app/common/country/country.service";
import { Modal } from 'flowbite';
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";


@Component({
    templateUrl: './countryselector.component.html',
    styleUrls: ['./countryselector.component.scss'],
    selector: 'countryselector',
    standalone: false
})
export class CountrySelectorComponent implements AfterViewInit {

  @Input() public selectedCountryIsoCode;

  @ViewChild('countriesPopup') public countriesPopup: CountriesPopupComponent;
  @ViewChild('selectcountry') public selectCountryElement: ElementRef<HTMLElement>;

  protected modal;

  public selectedCountry;

  constructor(public countryService: CountryService,
              @Inject(IS_BROWSER) protected isBrowser: boolean) {
    
    this.selectedCountry = this.countryService.getSelectedCountry();
    this.countryService.onCountrySelected$.subscribe(country => {
      console.log('country selected', country);
      this.selectedCountry = country;
    });
  }

  ngAfterViewInit() {
    this.modal = new Modal( this.selectCountryElement.nativeElement, {});
  }

  show() {
    this.showPopup();
  }

  showPopup() {
    if(this.isBrowser) {
      this.modal.show();
    }
  }

  showCountryList() {
    this.countriesPopup.show();
  }

  selectCountry(country) {
    this.countryService.setSelectedCountry(country.code);
  }

  closePopup() {
    this.modal.hide();
  }

}
